// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"d8c3c517","455":"25c67833","977":"8f3f1ee8"}[chunkId] + ".chunk.js";
};